import React from 'react';

import { useService } from '@xstate/react';

import { productBuilderMachine } from '../../../../../context/ProductBuilder/machine';
import { getPatternImages } from '../../../../../helpers/getPatternImages';

export const HoneycombVerticleDaynight = (
  props: React.SVGProps<SVGSVGElement>,
) => {
  const [state] = useService(productBuilderMachine);
  const patterUrl = getPatternImages(state);
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 556.7 409" {...props}>
      <defs>
        <pattern
          id="hcVerticleDaynight"
          patternUnits="userSpaceOnUse"
          width="100"
          height="100"
        >
          <image href={patterUrl} x="0" y="0" width="100" height="100" />
        </pattern>
      </defs>
      <path fill="url(#hcVerticleDaynight)" d="M5.02 409.07V.07h202.1v409z" />
      <path fill="#ddd3cd" d="M351.88 409.029v-409h202.1v409z" opacity={0.9} />
      <linearGradient
        id="hcVerticleDaynight__a"
        x1={-203.31}
        x2={205.74}
        y1={2583.766}
        y2={2583.766}
        gradientTransform="rotate(-90 -1084.219 1289.959)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.006} stopColor="#bbbcbe" />
        <stop offset={0.292} stopColor="#989ca0" />
        <stop offset={0.652} stopColor="#bfbec2" />
        <stop offset={0.865} stopColor="#9ea0a4" />
        <stop offset={1} stopColor="#a7a9ac" />
        <stop offset={1} stopColor="#c3c6ca" />
      </linearGradient>
      <path fill="url(#hcVerticleDaynight__a)" d="M212.1 0v409h-5V0z" />
      <linearGradient
        id="hcVerticleDaynight__b"
        x1={-203.31}
        x2={205.74}
        y1={2376.677}
        y2={2376.677}
        gradientTransform="rotate(-90 -1084.219 1289.959)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.006} stopColor="#bbbcbe" />
        <stop offset={0.292} stopColor="#989ca0" />
        <stop offset={0.652} stopColor="#bfbec2" />
        <stop offset={0.865} stopColor="#9ea0a4" />
        <stop offset={1} stopColor="#a7a9ac" />
        <stop offset={1} stopColor="#c3c6ca" />
      </linearGradient>
      <path fill="url(#hcVerticleDaynight__b)" d="M5 0v409H0V0z" />
      <linearGradient
        id="hcVerticleDaynight__c"
        x1={-203.31}
        x2={205.74}
        y1={2928.391}
        y2={2928.391}
        gradientTransform="rotate(-90 -1084.219 1289.959)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.006} stopColor="#bbbcbe" />
        <stop offset={0.292} stopColor="#989ca0" />
        <stop offset={0.652} stopColor="#bfbec2" />
        <stop offset={0.865} stopColor="#9ea0a4" />
        <stop offset={1} stopColor="#a7a9ac" />
        <stop offset={1} stopColor="#c3c6ca" />
      </linearGradient>
      <path fill="url(#hcVerticleDaynight__c)" d="M556.7 0v409h-5V0z" />
      <linearGradient
        id="hcVerticleDaynight__d"
        x1={-203.31}
        x2={205.74}
        y1={2726.037}
        y2={2726.037}
        gradientTransform="rotate(-90 -1084.219 1289.959)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.006} stopColor="#bbbcbe" />
        <stop offset={0.292} stopColor="#989ca0" />
        <stop offset={0.652} stopColor="#bfbec2" />
        <stop offset={0.865} stopColor="#9ea0a4" />
        <stop offset={1} stopColor="#a7a9ac" />
        <stop offset={1} stopColor="#c3c6ca" />
      </linearGradient>
      <path fill="url(#hcVerticleDaynight__d)" d="M354.4 0v409h-5V0z" />
      <linearGradient
        id="hcVerticleDaynight__e"
        x1={159.221}
        x2={713.435}
        y1={-223.186}
        y2={-223.186}
        gradientTransform="translate(-159.221 228.186)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.006} stopColor="#bbbcbe" />
        <stop offset={0.292} stopColor="#989ca0" />
        <stop offset={0.652} stopColor="#bfbec2" />
        <stop offset={0.865} stopColor="#9ea0a4" />
        <stop offset={1} stopColor="#a7a9ac" />
        <stop offset={1} stopColor="#c3c6ca" />
      </linearGradient>
      <path fill="url(#hcVerticleDaynight__e)" d="M0 0h554.2v10H0z" />
      <linearGradient
        id="hcVerticleDaynight__f"
        x1={436.328}
        x2={436.328}
        y1={-200.127}
        y2={-218.186}
        gradientTransform="translate(-159.221 228.186)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.489} stopOpacity={0} />
        <stop offset={1} stopOpacity={0.3} />
      </linearGradient>
      <path fill="url(#hcVerticleDaynight__f)" d="M0 10h554.2v18.1H0z" />
    </svg>
  );
};
